export default __webpack_public_path__ + "static/visually-appealing-mobile-2-671f73c74270454170ccc40320444939.webp";